// eslint-disable-next-line no-shadow
export var EButtonTypes;
(function (EButtonTypes) {
    EButtonTypes["SUBMIT"] = "submit";
    EButtonTypes["RESET"] = "reset";
    EButtonTypes["BUTTON"] = "button";
})(EButtonTypes || (EButtonTypes = {}));
